import i18n from '@/i18n';

export function getAreaCodeOptions() {
  return [
    { label: '+853', value: '+853' },
    { label: '+852', value: '+852' },
    { label: '+86', value: '+86' },
  ];
}

export function getCertificateType() {
  return [
    {
      label: i18n.t('certificateType.CHINESE_PASSPORT'),
      value: '8',
    },
    {
      label: i18n.t('certificateType.HONG_KONG_ID_CARD'),
      value: '9',
    },
    {
      label: i18n.t('certificateType.PASSPORT_OR_TRAVEL_DOCUMENT'),
      value: '12',
    },
    {
      label: i18n.t('certificateType.MACAU_NON_PERMANENT_RESIDENT_ID_CARD'),
      value: '14',
    },
    {
      label: i18n.t('certificateType.MACAU_PERMANENT_RESIDENT_ID_CARD'),
      value: '15',
    },
    {
      label: i18n.t('certificateType.FOREIGN_EMPLOYEE_IDENTITY_CARD'),
      value: '19',
    },
    {
      label: i18n.t('certificateType.CHINESE_RESIDENT_ID_CARD'),
      value: '20',
    },
    {
      label: i18n.t('certificateType.OFFICIAL_TRAVEL_TO_HK_MACAU_PERMIT'),
      value: '21',
    },
    {
      label: i18n.t('certificateType.TRAVEL_TO_HK_MACAU_PERMIT'),
      value: '22',
    },
    {
      label: i18n.t('certificateType.SPECIAL_STAY_PERMIT'),
      value: '23',
    },
  ];
}

export function getCompanyCertificateType() {
  return [
    {
      label: i18n.t('certificateType.COMMERCIAL_CODE'),
      value: 'commercialCode',
    },
     {
      label: i18n.t('certificateType.ORGANIZATION_CODE'),
      value: 'organizationCode',
    },
  ]
}

export function getCompanyType() {
  return [
    {
      label: i18n.t('Common.title.business'),
      value: 'PERSONAL',
    },
    {
      label: i18n.t('Common.title.company'),
      value: 'COMPANY',
    }]
}

export const statusOptions = () =>
  ["SUBMITTED", "PASSED", "NO_PASSED", "REMODIFY", "CLOSED", "IDENTITY"].map((item) => {
    return {
      label: i18n.t(`statusType.${item}`),
      value: item,
    };
  });

  export const updateTypeOptions = () =>
  ["update1", "update2", ].map((item) => {
    return {
      label: i18n.t(`updateTypeList.${item}`),
      value: item,
    };
  });

